<p
  [id]="id"
  class="error-message"
>
  {{ message }}
</p>
